import Vue from 'vue';
import ToastDom from './Toast.vue';
const ToastConstructor = Vue.extend(ToastDom);

export interface IOptions {
  icon?: string;
  type?: string; // toast icon
  value?: any;
  duration?: number; // toast close duration
}

const toastPool: Array<any> = [];
const typeMap: any = {
  error_network: require('./assets/network-err.svg'),
  failure: require('./assets/failure.svg'),
  success: require('./assets/success.svg'),
  warn: require('./assets/warning.svg'),
};

const getAnInstance = () => {
  if (toastPool.length) {
    const [instance] = toastPool;
    // eslint-disable-next-line
    toastPool.splice(0, 1);
    return instance;
  }
  return new ToastConstructor({
    el: document.createElement('div'),
  });
};

const returnAnInstance = (instance: any) => {
  if (instance) {
    toastPool.push(instance);
  }
};

const removeDom = (event: any) => {
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target);
  }
};

ToastConstructor.prototype.unset = function() {
  this.toastString = '';
  this.icon = '';
  this.toastType = '';
  this.toastIconType = '';
};

ToastConstructor.prototype.close = function() {
  this.toastShow = false;
  this.$el.addEventListener('transitionend', removeDom);
  this.closed = true;
  returnAnInstance(this);
};

const Toast = (options: IOptions) => {
  const defaultInterval = 1500;
  const duration = options.duration || defaultInterval;

  const instance = getAnInstance();
  instance.closed = false;
  instance.unset();
  clearTimeout(instance.timer);
  const type = options.type || '';
  instance.toastString = options.value;
  instance.toastType = options.type;
  instance.icon = typeMap[type];
  document.body.appendChild(instance.$el);
  Vue.nextTick(function() {
    instance.toastShow = true;
    instance.$el.removeEventListener('transitionend', removeDom);
    ~duration &&
      (instance.timer = setTimeout(function() {
        if (instance.closed) return;
        instance.close();
      }, duration));
  });
  return instance;
};
export default Toast;
